/**
 * 메인 실적 숫자 — 여기 한 곳에서만 고친다.
 *
 * 솔루션 수는 손으로 적지 않고 **목록에서 센다.** 제품을 더하거나 빼면 숫자가 같이 바뀌어,
 * 화면의 숫자와 실제 목록이 어긋날 일이 없다. 목록 자체가 "무엇을 셌는가"의 기록이기도 하다.
 */

/**
 * 프로젝트 수행 — 대표가 직접 수행한 건.
 * 2026년 3월 사업 인수 후 개인사업자로 10월까지 22건, 2025년 1월부터 합쳐 43건.
 * 건수를 고칠 때 기간의 끝(`to`)도 같이 고친다.
 */
export const PROJECTS = { count: 43, from: '2025년 1월', to: '2026년 10월' };

/**
 * ESL 관련 자체 개발 솔루션 — 17종 모두 2026년에 개발했다.
 * 개발 중인 것, 구버전, 계열 제품은 뺐다. 예약(rsvn)은 비연동으로 센다.
 */
const SOLUTION_GROUPS = [
    { label: '비연동', items: ['eslmanager-deco', 'eslmanager-pharm', 'esl-studio-color', 'esl-studio', 'rsvn'] },
    {
        label: '연동',
        items: ['rsvn_view', 'hdeslm_view', 'hdeslm_flex', 'hdeslm_zkong', 'hdeslm_tomato', 'hdeslm_iregen', 'hdeslm_xml'],
    },
    {
        label: 'PDA 앱',
        items: ['eslmanager-pharm-pda', 'ems-pda', 'hdeslm_flex_pda', 'hdeslm_flex_m3_pda', 'hdeslm_zkong_pda'],
    },
];

// 같은 제품이 두 번 적혀도 한 번만 센다(처음 받은 목록에 hdeslm_zkong 이 두 번 있었다).
const unique = (xs) => [...new Set(xs)];

export const SOLUTIONS = {
    count: unique(SOLUTION_GROUPS.flatMap((g) => g.items)).length,
    year: 2026,
    /** 비연동 5 · 연동 7 · PDA 앱 5 — 숫자가 부풀린 게 아니라는 것을 구성으로 보여 준다. */
    groups: SOLUTION_GROUPS.map((g) => ({ label: g.label, count: unique(g.items).length })),
};
